import React, { FunctionComponent, MouseEvent } from "react";
import { useIntl } from "react-intl";
import { ReactComponent as IconDown } from "../../../../icons/chevron-down.svg";
import Button from "../../../atoms/Button";
import "./style.scss";

interface Props {
  onClick: (event: MouseEvent) => void;
}

const SelectionPagination: FunctionComponent<Props> = ({ onClick }) => {
  const intl = useIntl();

  return (
    <div className="SelectionPagination">
      <Button type="primary" onClick={onClick}>
        {intl.formatMessage({ id: "kustom_SelectionPagination_seeMore" })} <IconDown />
      </Button>
    </div>
  );
};

export default SelectionPagination;
